import { QuadStarIcon, Typography } from '@ag1/ui';
import clsx from 'clsx';
import styles from './UpgradedFormula.module.scss';

type UpgradedFormulaProps = {
  textClassName?: string;
  text: string;
};

export const UpgradedFormula = ({ textClassName, text }: UpgradedFormulaProps) => (
  <div className={styles.upgradedBadge}>
    <QuadStarIcon size={16} className={styles.upgradeIcon} />
    <Typography
      variant="bodyMono"
      size="2"
      color="brand-green-new"
      noPadding
      className={clsx(textClassName, styles.upgradeLabel)}>
      {text}
    </Typography>
  </div>
);
